import { CommonLaboratoryResponse, EnumResponse } from '@/api/services/common.dto'
import { CustomerResponse } from '@/api/services/billing/common-customer/billing-common-customer.dto'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'
import { PaymentMethodResponse } from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.dto'
import { InvoiceResponse } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { Nullable, StrictNullable } from '@/shared/types/app.types'

export enum InvoicePaymentStatus {
    GENERATED = 'GENERATED',
    CANCELLED = 'CANCELLED',
    VERIFIED = 'VERIFIED'
}
export interface InvoicePaymentStatusEnumResponse extends EnumResponse {
    code: InvoicePaymentStatus
}

export interface InvoicePaymentResponse {
    id: number
    laboratory: CommonLaboratoryResponse
    customer: StrictNullable<CustomerResponse>
    label: string
    status: InvoicePaymentStatusEnumResponse
    invoice: InvoiceResponse
    generationDate: string
    generator: CommonPersonnelResponse
    cancellationDate: StrictNullable<string>
    canceller: StrictNullable<CommonPersonnelResponse>
    verificationDate: StrictNullable<string>
    verifier: StrictNullable<CommonPersonnelResponse>
    conceptsRealTotalValue: number
    invoiceAccountingUnit: AccountingUnitResponse
    externalReference: StrictNullable<string>
    paymentDate: StrictNullable<string>
    paymentMethod: StrictNullable<PaymentMethodResponse>
    sentToGovernmentRevenueServices: boolean
    billableDeliveryNoteCount: number
    appliedBillableConceptCount: number
}

export interface InvoicePaymentPatchRequest {
    id: number
    externalReference?: Nullable<string>
    sentToGovernmentRevenueServices?: Nullable<boolean>
    paymentDate?: Nullable<string>
    paymentMethodId?: Nullable<number>
}
